import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ConfigurationField from './ConfigurationField';
import SectionHeader from './SectionHeader';
import {
  SECTION_BOTTOM_MARGIN,
  SECTION_GRID_SPACING,
} from '../managedAccount.constants';

const PositivePayDeliverySection = ({
  form,
  fieldErrors,
  onChange,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <SectionHeader>
        {t('managedAccounts.positivePay.delivery.title')}
      </SectionHeader>
      <Grid
        container
        spacing={SECTION_GRID_SPACING}
        sx={{ mb: SECTION_BOTTOM_MARGIN }}>
        <Grid item xs={12} md={6}>
          <ConfigurationField
            name='outbound_path'
            label={t('managedAccounts.positivePay.delivery.outboundPath')}
            value={form.outbound_path}
            onChange={onChange}
            error={fieldErrors.outbound_path}
            disabled={disabled}
            tooltip={t(
              'managedAccounts.positivePay.delivery.outboundPathTooltip',
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <ConfigurationField
            name='positive_pay_prefix'
            label={t('managedAccounts.positivePay.delivery.prefix')}
            value={form.positive_pay_prefix}
            onChange={onChange}
            error={fieldErrors.positive_pay_prefix}
            disabled={disabled}
            tooltip={t('managedAccounts.positivePay.delivery.prefixTooltip')}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default PositivePayDeliverySection;
